import getBlockchainTransaction from "/public/graphQl/queries/getBlockchainTransaction";

export const fetchBlockChainTransaction = async ({dispatch, commit, rootGetters}, payload) => {
    let transactionData;

    const organizationId = rootGetters['app/getSelectedOrganization'].id;
    const variables = {
        organizationId,
        ...payload,
    };

    try {
        commit('app/toggleLoading', null, {root: true});
        transactionData = await dispatch('app/request', {
            type: 'query',
            gql: getBlockchainTransaction,
            variables,
        }, {root: true});
    } catch (error) {
        return error;
    } finally {
        commit('app/toggleLoading', null, {root: true});
    }

    if (transactionData.message) {
        throw transactionData.message;
    }

    if (transactionData.errors) {
        throw transactionData.errors;
    }

    const {
        data: {getBlockchainTransaction: getTransaction},
    } = transactionData;

    return getTransaction;
};